var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "module-header" }, [
    _c("div", { staticClass: "author-sign" }, [
      _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.moduleName))]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "by-author" },
        [
          _c("el-tag", { attrs: { type: "info", size: "mini" } }, [
            _vm._v("by " + _vm._s(_vm.authorName))
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec1c6010", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec1c6010","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/authorSign.vue
// module id = 1236
// module chunks = 7